import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightText',
})


  export class HighlightTextPipe implements PipeTransform {
    transform(value: string): string {
      if (!value) return value;
  
      // Détecter les hashtags et liens
      const hashtagRegex = /#(\w+)/g;
      const urlRegex = /(https?:\/\/[^\s]+)/g;
  
      // Ajouter du style pour les hashtags et transformer les URLs en hyperliens
      return value
        .replace(hashtagRegex, `<span style="color: blue;">#$1</span>`)
        .replace(urlRegex, `<a href="$1" target="_blank" style="color: blue;">$1</a>`);
    }
  }





